import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetExamsDistricts,
	GetExamsDistrictsModel,
	GetExamsDistrictsParams,
} from 'domain/usecases/private/booking-flow/exams/get-exams-districts';

export class RemoteGetExamsDistricts implements GetExamsDistricts {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsDistrictsModel>,
	) {}

	async get({signal, ...params}: GetExamsDistrictsParams): Promise<GetExamsDistrictsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
